import React from 'react';
import { Flame, Instagram, Facebook, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { siteData } from '../mock';

const Footer = () => {
  const { footer, brand, address } = siteData;
  return (
    <footer className="bg-[#0a1030] text-white py-16 px-6 md:px-12">
      <div className="max-w-[1300px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Flame className="h-6 w-6 text-white" strokeWidth={2.5} />
              <span className="font-extrabold tracking-wide text-[14px]">
                {brand.name}
              </span>
            </div>
            <p className="text-white/70 text-sm max-w-[280px] leading-relaxed">
              {footer.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-white/60 uppercase text-xs tracking-widest mb-4">Visit</h4>
            <div className="flex items-start gap-2 text-white/85 text-sm mb-3">
              <MapPin className="h-4 w-4 mt-0.5" />
              <span>{address}</span>
            </div>
            <div className="flex items-center gap-2 text-white/85 text-sm mb-3">
              <Mail className="h-4 w-4" />
              <a href={`mailto:${footer.email}`} className="hover:text-white">{footer.email}</a>
            </div>
            <div className="flex items-center gap-2 text-white/85 text-sm">
              <Phone className="h-4 w-4" />
              <a href={`tel:${footer.phone.replace(/[^0-9+]/g, '')}`} className="hover:text-white">{footer.phone}</a>
            </div>
          </div>

          <div>
            <h4 className="text-white/60 uppercase text-xs tracking-widest mb-4">Connect</h4>
            <div className="flex items-center gap-4">
              <a
                href={footer.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="h-9 w-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 hover:border-white/40 transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={footer.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="h-9 w-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 hover:border-white/40 transition-colors"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={footer.youtube}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="h-9 w-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 hover:border-white/40 transition-colors"
              >
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-white/50 text-xs flex flex-col md:flex-row items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Apostolic Christ Tabernacle. All rights reserved.</span>
          <span>Made with care in Gilroy, CA</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
